/**
 * MDL Blog / Collection Guide UTM tagger
 *
 * 目的: 検索エンジン経由(Google/Yahoo/Bing 等) で来訪したセッションのみ、
 *      記事本文 / コレクションガイド内の EC リンク (/products, /collections)
 *      に UTM パラメータを自動付与して 流入経路と売上を計測できるようにする。
 *
 * 動作:
 *   1. セッション初回に document.referrer を判定
 *      検索エンジンなら sessionStorage['mdl_search_src'] に source (google/yahoo/…) を保存
 *   2. scope要素 (data-utm-medium を持つ) 内の内部ECリンクを走査
 *   3. 検索経由セッションであれば UTM を付与
 *      - utm_source = google/yahoo/bing…
 *      - utm_medium = data-utm-medium (article / collection-guide 等)
 *      - utm_campaign = data-utm-campaign (article.handle 等)
 *      - utm_content = a.dataset.utmContent (任意、カード等で個別指定)
 *
 * SPA的なDOM書き換え・後から挿入されるリンクにも対応するため
 * MutationObserver も併用。
 */
(function () {
  'use strict';

  var SEARCH_MAP = [
    { re: /(?:^|\.)google\./i, source: 'google' },
    { re: /(?:^|\.)yahoo\./i, source: 'yahoo' },
    { re: /(?:^|\.)bing\./i, source: 'bing' },
    { re: /duckduckgo\.com$/i, source: 'duckduckgo' },
    { re: /(?:^|\.)yandex\./i, source: 'yandex' },
    { re: /(?:^|\.)baidu\./i, source: 'baidu' }
  ];

  function detectSearchSource() {
    try {
      var ref = document.referrer;
      if (!ref) return '';
      var host = (new URL(ref)).host.toLowerCase();
      for (var i = 0; i < SEARCH_MAP.length; i++) {
        if (SEARCH_MAP[i].re.test(host)) return SEARCH_MAP[i].source;
      }
    } catch (e) {}
    return '';
  }

  // テスト用: ?utm_test=1 または ?utm_test=<source名> で強制的に検索経由扱い
  var forcedTest = '';
  try {
    var q = new URL(window.location.href).searchParams.get('utm_test');
    if (q) {
      forcedTest = (q === '1') ? 'google' : q;
      sessionStorage.setItem('mdl_search_src', forcedTest);
    }
  } catch (e) {}

  var searchSource = forcedTest;
  if (!searchSource) {
    try {
      var cached = sessionStorage.getItem('mdl_search_src');
      if (cached === null) {
        searchSource = detectSearchSource();
        sessionStorage.setItem('mdl_search_src', searchSource);
      } else {
        searchSource = cached;
      }
    } catch (e) {
      searchSource = detectSearchSource();
    }
  }
  if (!searchSource) return; // 検索経由でなければ何もしない

  // EC 内部リンク判定: 相対 /products/ /collections/ もしくは mdlmake 系ドメインの同パス
  var EC_URL_RE = /^(?:https?:\/\/(?:mdlmake\.shop|mdlmake\.myshopify\.com|1a0dbe-2\.myshopify\.com))?\/(?:products|collections)\//;

  function tagLink(a, medium, campaign) {
    if (a.dataset.utmProcessed === '1') return;
    var href = a.getAttribute('href');
    if (!href) return;
    if (!EC_URL_RE.test(href)) return;
    if (/[?&]utm_source=/.test(href)) return; // 既に付与済み

    var params = [
      'utm_source=' + encodeURIComponent(searchSource),
      'utm_medium=' + encodeURIComponent(medium)
    ];
    if (campaign) params.push('utm_campaign=' + encodeURIComponent(campaign));
    var content = a.dataset.utmContent;
    if (content) params.push('utm_content=' + encodeURIComponent(content));
    var sep = href.indexOf('?') === -1 ? '?' : '&';
    a.setAttribute('href', href + sep + params.join('&'));
    a.dataset.utmProcessed = '1';
  }

  function tagContainer(c) {
    var medium = c.dataset.utmMedium;
    if (!medium) return;
    var campaign = c.dataset.utmCampaign || '';
    var anchors = c.querySelectorAll('a[href]');
    anchors.forEach(function (a) { tagLink(a, medium, campaign); });
  }

  function tagAll() {
    var containers = document.querySelectorAll('[data-utm-medium]');
    containers.forEach(tagContainer);
  }

  function init() {
    tagAll();
    // 後から挿入されるリンクにも対応
    try {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) {
            tagAll();
            return;
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
